import { ConfigService } from 'src';

// Define an object to hold the base URLs
let baseUrls: {
  baseURL: string;
  baseURLV2: string;
  baseURLTenantV2: string;
  baseURLHost: string;
  securityServiceV1: string;
} | null = null;

// Function to initialize the base URLs
export const initializeBaseUrls = async () => {
  await ConfigService.waitForConfig();
  const config = ConfigService.config;
  baseUrls = {
    baseURL: config.UNITY_API_DOMAIN + config.INTEGRATION_V1_API_BASE,
    baseURLV2: config.UNITY_API_DOMAIN + config.INTEGRATION_V2_API_BASE,
    baseURLTenantV2: config.UNITY_API_DOMAIN + config.TENANT_V2_API_BASE,
    baseURLHost: config.HOST_API_DOMAIN + config.V1_API_BASE,
    securityServiceV1: config.UNITY_API_DOMAIN + config.SECURITY_SERVICE_V1_API_BASE,
  };
  console.log('Base URLs:', baseUrls);
};

// Function to get the base URLs
export const getBaseUrls = async () => {
  if (!baseUrls) {
    await initializeBaseUrls();
  }
  return baseUrls;
};